import { useMemo } from 'react';

import { useCacheQuery } from '../../../hooks/use-cache-query';
import {
  GetHealthProviderItemsDocument,
  HealthProviderItemDataFragment,
} from '../../types/api/graphql';

export function useDefaultHealthProviderItems(skip: boolean = false) {
  const { data: healthProviderItemsData, loading: healthProviderItemsLoading } =
    useCacheQuery(GetHealthProviderItemsDocument, {
      skip,
    });

  const data = useMemo(
    () =>
      (healthProviderItemsData?.healthProviders ?? []).map(
        option => option as HealthProviderItemDataFragment
      ),
    [healthProviderItemsData?.healthProviders]
  );

  return {
    data,
    loading: healthProviderItemsLoading,
  };
}
